import "./Hero.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

import hero2 from "../../assets/images/hero2.jpg";
import hero3 from "../../assets/images/hero3.jpg";

const slides = [
  {
    image: hero2,
    brand: "YADNYA HANDLOOM",
    subtitle: "Royal Handcrafted Sarees",
    title: "Wear the Grace\nof Tradition",
    description:
      "From luxurious Paithanis to exquisite Silk Sarees, every weave tells a story of craftsmanship and heritage.",
  },
  {
    image: hero3,
    brand: "YADNYA HANDLOOM",
    subtitle: "Festive Collection",
    title: "Celebrate Every\nSpecial Moment",
    description:
      "Exclusive festive and bridal sarees designed to make every occasion graceful, elegant and unforgettable.",
  },
];

const Hero = () => {
  return (
    <section className="hero">

      <Swiper
        modules={[Autoplay, EffectFade, Pagination]}
        className="heroSwiper"
        effect="fade"
        loop={true}
        speed={1200}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
        }}
      >

        {slides.map((slide, index) => (

          <SwiperSlide key={index}>

            <div className="hero-slide">

              <div className="hero-image-wrapper">

                <img
                  src={slide.image}
                  alt={slide.title}
                  className="hero-image"
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  draggable="false"
                />

              </div>

              <div className="hero-overlay"></div>

              <div className="hero-content">

                <div className="brand-badge">
                  {slide.brand}
                </div>

                <span className="hero-subtitle">
                  {slide.subtitle}
                </span>

                <h1>

                  {slide.title.split("\n").map((line, i) => (

                    <span key={i}>
                      {line}
                    </span>

                  ))}

                </h1>

                <p>
                  {slide.description}
                </p>

              </div>

            </div>

          </SwiperSlide>

        ))}

      </Swiper>

    </section>
  );
};

export default Hero;